import { useMemo } from 'react';

export const useCreateTaxa = () => {
    return useMemo(() => {
        return [
            {
                name: 'dataInicio',
                label: 'Data Início',
                type: 'mask',
                required: true,
                mask: '99/99/9999 99:99',
                placeholder: 'DD/MM/YYYY HH:MM',
                grid: '1fr'
            },
            {
                name: 'dataFim',
                label: 'Data Fim',
                type: 'mask',
                required: true,
                mask: '99/99/9999 99:99',
                placeholder: 'DD/MM/YYYY HH:MM',
                grid: '1fr'
            },
            {
                name: 'valorAdicionalJogoRapido',
                label: 'Valor Adicional Jogo Rápido',
                type: 'money',
                required: true,
                placeholder: 'Digite o valor adicional para jogo rápido',
                grid: '1fr'
            },
            {
                name: 'valorAdicionalEntregador',
                label: 'Valor Adicional Entregador',
                type: 'money',
                required: true,
                placeholder: 'Digite o valor adicional para entregador',
                grid: '1fr'
            }
        ];
    }, []);
};